import styled from "styled-components";
import { TextButton } from "@swiggy-private/dls-web-core/dist/components/TextButton";

export const RedeemButton = styled(TextButton)(({ theme }) => ({
    paddingLeft: theme.spacing.xSmall,
    width: "initial",
}));

export const Container = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: `${theme.spacing.xSmall} ${theme.spacing.medium}`,
}));
